
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const renderAutoComplete = ({ id, dataOptions, label, options, input, getData, field, ...other}) => {
    return  <Autocomplete
                id={id}
                options={options}
                disableClearable
                onChange = { (e, v )=> {
                    getData(v)
                }}
                getOptionLabel={option => {
                    if (field === undefined) {
                        return option.name
                    } else {
                        return option[field]
                    }
                }}
                renderInput={params => (
                <TextField {...params} name={id} label={label} fullWidth />
                )}

            />
}

renderAutoComplete.propTypes = {
    options: PropTypes.array.isRequired,
}; 

export default renderAutoComplete;